import { render, staticRenderFns } from "./Inspectionrecord.vue?vue&type=template&id=408e0bfc&scoped=true&"
import script from "./Inspectionrecord.vue?vue&type=script&lang=js&"
export * from "./Inspectionrecord.vue?vue&type=script&lang=js&"
import style0 from "./Inspectionrecord.vue?vue&type=style&index=0&id=408e0bfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408e0bfc",
  null
  
)

export default component.exports